import { QueryClient } from '@tanstack/react-query';

export function createBlockScanQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        retry(failureCount, error) {
          if (error?.code === 'invalid_request' || error?.code === 'not_found') return false;
          return Boolean(error?.retriable) && failureCount < 2;
        },
        retryDelay: (attempt) => Math.min((800 * (2 ** attempt)) + (Math.random() * 250), 4000),
      },
    },
  });
}
